import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-286bce84"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["transform"]

import { overlap, Snake } from "@/utils/snake";
import { useStore } from "../store";
import Block from "@/components/Block.vue";
import { ref, computed, watch, inject } from "vue";
import { BlockWithUUID, Vector2, WrapTailBlock } from "@/utils/block";
import { DeepReadonly } from "@/utils/deep-readonly";
import { getAbsolutePositionKey } from "./Program.vue";
import { CursorMode } from "./CursorMode.vue";
import WrapConnector from "./WrapConnector.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    snake: null,
    cursorMode: null
  },
  setup(__props: any) {

const props = __props as {
  snake: DeepReadonly<Snake>;
  cursorMode: CursorMode;
}



const blockWithPosition = computed<[number, BlockWithUUID][]>(() => {
  let accumulatedX = 0;
  return props.snake.blocks.map((block) => {
    const result: [number, BlockWithUUID] = [accumulatedX, block];
    accumulatedX += block.design.width - overlap;
    return result;
  });
});

const getAbsolutePosition = inject(getAbsolutePositionKey);

let currentSnake = ref(Snake.copy(props.snake));
// props.snake: not working
watch(
  props,
  () => {
    currentSnake.value = Snake.copy(props.snake);
  },
  { flush: "post" }
);

const { splitHead, splitTail, wrapSnake, setGrabbing, snakes, updateBlock } =
  useStore();
const wrapInfo = computed<DeepReadonly<[Vector2, Vector2]> | null>(() => {
  const head = currentSnake.value.blocks[currentSnake.value.blocks.length - 1];
  if (head instanceof WrapTailBlock) {
    if (snakes[head.connectTo]?.visible) {
      return [currentSnake.value.anchorNext, snakes[head.connectTo].anchorTail];
    }
  }
  return null;
});
let touchingBlockUUID: string | null = null;
let timeoutId: number | null = null;
let isDown = false;
const mousedown = (blockUUID: string) => {
  isDown = true;
  if (touchingBlockUUID !== null) {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    touchingBlockUUID = null;
    doubleclick(blockUUID);
  } else {
    touchingBlockUUID = blockUUID;
    timeoutId = setTimeout(() => {
      touchingBlockUUID = null;
      if (isDown) {
        down(blockUUID);
      }
    }, 350);
  }
};
const mouseup = (blockUUID: string) => {
  isDown = false;
};
const mousemove = (blockUUID: string, e: PointerEvent) => {
  if (
    touchingBlockUUID !== null &&
    Math.abs(e.movementX ** 2 + e.movementY ** 2) > 0.1
  ) {
    if (isDown) {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
      touchingBlockUUID = null;
      down(blockUUID);
    }
  }
};

const down = (blockUUID: string) => {
  // blockUUID was used for splitting.
  if (props.cursorMode === "move") {
    setGrabbing(currentSnake.value.uuid, blockUUID);
  }
};

const anchorTail = computed(() => currentSnake.value.anchorTail);
const x = computed(() => anchorTail.value[0]);
const y = computed(() => anchorTail.value[1]);

const doubleclick = (blockUUID: string) => {
  splitTail(currentSnake.value.uuid, blockUUID, true);
  splitHead(currentSnake.value.uuid, blockUUID, true);
};

const click = (event: MouseEvent) => {
  if (props.cursorMode === "wrap") {
    if (!getAbsolutePosition) {
      throw new Error("Injected getAbsolutePosition is undefined.");
    }
    const x =
      getAbsolutePosition([event.pageX, event.pageY])[0] -
      props.snake.anchorTail[0];
    let closestBlock: BlockWithUUID | null = null;
    let accumulatedWidth = 0;
    let beforeDistance = x - 0;
    for (const block of Object.values(props.snake.blocks)) {
      accumulatedWidth += block.design.width - overlap;
      const newDistance = Math.abs(x - accumulatedWidth);
      if (beforeDistance < newDistance) {
        break;
      }
      beforeDistance = newDistance;
      closestBlock = block;
    }
    if (
      closestBlock?.uuid ===
      props.snake.blocks[props.snake.blocks.length - 1].uuid
    ) {
      closestBlock === null;
    }
    if (closestBlock) {
      wrapSnake(currentSnake.value.uuid, { before: closestBlock.uuid });
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", null, [
    _createElementVNode("g", {
      transform: `translate(${_unref(x)}, ${_unref(y)})`,
      onClick: click
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blockWithPosition), ([x, block]) => {
        return (_openBlock(), _createBlock(Block, {
          onPointerdown: ($event: any) => (mousedown(block.uuid)),
          onPointermove: 
          (e) => {
            mousemove(block.uuid, e);
          }
        ,
          onPointerup: ($event: any) => (mouseup(block.uuid)),
          key: block.uuid,
          block: block,
          "update-block": 
          (updater) => _unref(updateBlock)(_unref(currentSnake).uuid, block.uuid, updater)
        ,
          x: x,
          y: 0,
          "show-tooltip": ""
        }, null, 8, ["onPointerdown", "onPointermove", "onPointerup", "block", "update-block", "x"]))
      }), 128))
    ], 8, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: ".program-inner-back" }, [
      (_unref(wrapInfo) !== null)
        ? (_openBlock(), _createBlock(WrapConnector, {
            key: 0,
            positions: _unref(wrapInfo)
          }, null, 8, ["positions"]))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})